export default "__VITE_ASSET__BCrhqegL__"